import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue";
var _hoisted_1 = { class: "tw-max-w-4xl tw-m-auto tw-flex tw-justify-around tw-items-center tw-py-3 tw-gap-x-4 tw-gap-y-2 tw-flex-wrap" };
var _hoisted_2 = ["href"];
var _hoisted_3 = ["src", "alt", "title"];
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Logos',
    props: {
        localizationCode: {}
    },
    setup: function (__props) {
        var props = __props;
        var isCZ = computed(function () { return ['CZ', 'SK'].includes(props.localizationCode); });
        var logos = computed(function () { return [
            {
                name: 'NET service solution, s.r.o.',
                img: 'logo_net-service_grey.svg',
                href: isCZ.value ? 'https://www.net-service.cz' : 'https://www.net-service.cz/en',
            },
            {
                name: 'ISPadmin',
                img: 'logo_ispadmin_grey.svg',
                href: isCZ.value ? 'https://ispadmin.eu' : 'https://ispadmin.eu/en',
            },
            {
                name: 'FlowPRO',
                img: 'logo_flowpro_ng_grayscale.svg',
                href: 'https://www.flowpro.eu',
            },
            {
                name: 'VPNpilot',
                img: 'logo_vpnpilot_grey.svg',
                href: isCZ.value ? 'https://www.vpnpilot.eu' : 'https://www.vpnpilot.eu/en',
            },
            {
                name: 'SolarPilot',
                img: 'logo_solarpilot_grey.svg',
                href: 'https://www.solarpilot.eu',
            },
        ]; });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(logos.value, function (logo) {
                    return (_openBlock(), _createElementBlock("a", {
                        key: logo.name,
                        href: logo.href,
                        target: "_blank",
                        rel: "noopener noreferrer"
                    }, [
                        _createElementVNode("img", {
                            class: "tw-max-h-6",
                            src: "/images/logos/".concat(logo.img),
                            alt: logo.name,
                            title: logo.name
                        }, null, 8 /* PROPS */, _hoisted_3)
                    ], 8 /* PROPS */, _hoisted_2));
                }), 128 /* KEYED_FRAGMENT */))
            ]));
        };
    }
});
